import React, { FunctionComponent } from 'react';

type Props = {
  personId: number;
  title: string;
  target: string;
  scoutId: number;
  scoutTitle: string;
  scoutCreatedAt: string;
  scoutMessage: string;
};

export const Presentation: FunctionComponent<Props> = ({
  personId,
  title,
  target,
  scoutId,
  scoutTitle,
  scoutCreatedAt,
  scoutMessage,
}) => {
  return (
    <div className="person__show__modal__inner">
      <div className="person__show__modal__inner__scout">
        <p className="semiTitle">送信日</p>
        <p className="body">{scoutCreatedAt}</p>
      </div>
      <div className="person__show__modal__inner__scout">
        <p className="semiTitle">求人タイトル</p>
        <p className="body">{scoutTitle}</p>
      </div>
      <div className="person__show__modal__inner__scout">
        <p className="semiTitle">スカウト内容</p>
        <div dangerouslySetInnerHTML={{ __html: scoutMessage }} className='body'/>
      </div>
    </div>
  );
};
